import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'poster' | 'horizontal';
}

export default function MovieCard({ movie, variant = 'poster' }: MovieCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${movie.id}`}
        className="group flex gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-all duration-200 cursor-pointer"
      >
        <div className="w-28 h-40 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={movie.posterImage}
            alt={movie.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            title={`${movie.title} - 97影院高清在线观看`}
          />
        </div>
        <div className="flex flex-col justify-between py-1 min-w-0">
          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
              {movie.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">{movie.englishTitle}</p>
            <div className="flex items-center gap-2 mt-2">
              <span className="px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700">{movie.category}</span>
              <span className="text-xs text-foreground-500">{movie.year}</span>
            </div>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {movie.rating}
            </span>
            <span>{movie.duration}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.posterImage}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${movie.title} - 97影院高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-xs rounded-md bg-primary-500 text-white font-medium">
            {movie.rating}
          </span>
        </div>
        {movie.type === 'tv' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs rounded-md bg-accent-500 text-white font-medium">剧集</span>
          </div>
        )}
        {movie.updateStatus === '即将上映' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-xs rounded-md bg-secondary-500 text-white font-medium">即将上映</span>
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{movie.category}</span>
        </div>
      </div>
    </Link>
  );
}